import { Spiner, SpinerPage } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { BsArrowDownLeft, BsArrowUpRight } from "react-icons/bs";
import { FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AvatarImage from "@assets/images/avatar-.png";
import { SchoolService } from "@services/school.service";
import { HomeService } from "@services/home.service";
import { BiFilter, BiPlus } from "react-icons/bi";
import { PopupCustom } from "@components/generals/popup";
import { FaChevronDown } from "react-icons/fa";

export const BalancePage = () => {
  const navigate = useNavigate();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<"10" | "20" | "50">("10");
  const [showBalance, setShowBalance] = useState<boolean>(true);
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataSiswa } = useQuery(
    [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    SchoolService.studentBio,
  );
  const nis = dataSiswa?.data?.nis ?? "";

  const { data: dataUangSaku, isLoading: isLoadingUangSaku } = useQuery(
    [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    () => HomeService.billsAndBalances({ nis }),
  );

  const { data, isLoading } = useQuery(
    [FinanceService.queries.GET_HISRTORY_BALANCE, nis, limit],
    () => FinanceService.historyBalance({ nis, limit }),
  );

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Uang Saku",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ leading: "back", title: "Uang Saku" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <SpinerPage show={isLoading} />
      <div className="card card-style">
        <div className="content mt-2 mb-0">
          <div className="d-flex justify-content-between align-items-center my-2">
            <div>
              <div className="!tw-text-gray-500 dark:!tw-text-gray-500 tw-text-sm mb-2">
                Uang Saku Tersedia
              </div>
              <div className="d-flex align-items-center gap-3">
                <h2 className="text-3xl font-bold mb-0">
                  {isLoadingUangSaku ? (
                    <div className="tw-py-2 m-auto">
                      <Spiner className="!tw-text-gray-500 dark:!tw-text-gray-500 tw-w-6 tw-h-6" />
                    </div>
                  ) : showBalance ? (
                    toRp(dataUangSaku?.data?.saldo ?? 0)
                  ) : (
                    "Rp ••••••"
                  )}
                </h2>
                {/* <button
                  onClick={() => setShowBalance(!showBalance)}
                  className="text-gray-400 hover:text-white"
                >
                  {showBalance ? <BsEye size={20} /> : <FiEyeOff size={20} />}
                </button> */}
              </div>
            </div>
            <div className="bg-green-700 p-3 rounded-full">
              <img
                src={AvatarImage}
                width="50"
                alt="avatar"
                className="bg-highlight rounded-xl"
              />
            </div>
          </div>
        </div>
        <div className="tw-flex tw-gap-3 mt-1 content">
          <div
            className="tw-w-1/2 tw-text-white tw-bg-green-600 hover:tw-bg-green-700 tw-rounded-xl tw-py-2 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold tw-transition"
            onClick={() =>
              navigate(linkPage.FINANCE_VIRTUAL_ACCOUNT_REQUEST, {
                state: { title: "Request VA", tagihan: true },
              })
            }
          >
            <BiPlus size={20} />
            Top Up
          </div>
          <div
            className="tw-w-1/2 tw-text-white tw-bg-gray-700 hover:tw-bg-gray-600 tw-rounded-xl tw-py-2 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold tw-transition"
            onClick={() => setPopupFilter(true)}
          >
            <BiFilter size={20} />
            Filter
          </div>
        </div>
      </div>

      <div className="card card-style mb-0">
        <div className="tw-mb-2 tw-mt-3 tw-px-4 tw-text-lg tw-font-bold tw-text-black dark:tw-text-white">
          Riwayat Transaksi Uang Saku
        </div>
        {data?.data != null && data.data.length > 0 ? (
          <div className="tw-space-y-3">
            {data?.data.map((item, idx) => (
              <div
                key={idx}
                className="tw-p-4 tw-flex tw-items-center tw-justify-between"
              >
                <div className="tw-flex tw-items-center tw-gap-4 tw-w-2/3">
                  <div
                    className={`tw-p-3 tw-rounded-full ${
                      item.filter === "IN"
                        ? "tw-bg-green-900/70 tw-text-green-400"
                        : "tw-bg-red-900/70 tw-text-red-400"
                    }`}
                  >
                    {item.filter === "IN" ? (
                      <BsArrowDownLeft size={20} />
                    ) : (
                      <BsArrowUpRight size={20} />
                    )}
                  </div>
                  <div>
                    <div className="tw-text-sm tw-text-black dark:tw-text-white tw-font-semibold">
                      {item.description}
                    </div>
                    <div className="tw-text-gray-400 tw-text-xs tw-mt-1">
                      {new Date(item.tanggal).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </div>
                  </div>
                </div>
                <div className="tw-text-right tw-w-1/3">
                  <div
                    className={`tw-font-bold tw-text-sm ${
                      item.filter === "IN"
                        ? "tw-text-green-400"
                        : "tw-text-red-400"
                    }`}
                  >
                    {item.filter === "IN" ? "+" : "-"}
                    {toRp(item.nominal)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      <PopupCustom
        show={popupFilter}
        position="bottom"
        height={320}
        onCancel={() => setPopupFilter(false)}
      >
        <div className="pb-2 px-3">
          <h4 className="font-700 mt-3">Filter Riwayat Transaksi</h4>
          <div className="divider mt-3 mb-3"></div>
          <div className="input-style has-borders input-style-always-active no-icon mb-4">
            <label htmlFor="form5" className="color-highlight font-500">
              Jumlah ditampilkan
            </label>
            <select
              defaultValue="10"
              onChange={(e) => setLimit(e.target.value as "10" | "20" | "50")}
              className="bg-theme"
            >
              <option value="default" disabled>
                Jumlah ditampilkan
              </option>
              <option value="10">10 Data Terakhir</option>
              <option value="20">20 Data Terakhir</option>
              <option value="50">50 Data Terakhir</option>
            </select>
            <span>
              <i>
                <FaChevronDown />
              </i>
            </span>
          </div>
          <div className="divider !tw-my-2" />
          <button
            className="btn btn-sm btn-full rounded-xs text-uppercase font-900 shadow-s bg-red-dark tw-grow my-3 tw-w-full tw-h-11"
            onClick={() => setPopupFilter(false)}
          >
            Tutup
          </button>
        </div>
      </PopupCustom>
    </>
  );
};
